import { isLocale, type Locale } from './locales';

export const LOCALE_STORAGE_KEY = 'apis:locale';

/** localStorage can throw (private mode, disabled storage, SSR); always guard it. */
export function readStoredLocale(key: string = LOCALE_STORAGE_KEY): Locale | null {
  try {
    if (typeof window === 'undefined') return null;
    const value = window.localStorage.getItem(key);
    return isLocale(value) ? value : null;
  } catch {
    return null;
  }
}

export function writeStoredLocale(locale: Locale, key: string = LOCALE_STORAGE_KEY): void {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(key, locale);
  } catch {
    // Storage unavailable: the choice simply is not remembered.
  }
}
